<template>
    <div style="min-height: calc(100vh - 158px);">
        
        <div :style="{opacity: loading ? '.5' : '1'}" class="card p-2 mt-3">
            <TitleButton
                btnTitle="Go Back"
                title="Edit Business"
                @onClickCloseButton="goToList"
            />
            <hr>
            <AddFormElement
                class="mb-2"
                :data="business"
            />
            
            <div class="mt-2 text-center">
                <hr class="mb-1">
                <button
                    @click="saveBusiness(true)"
                    class="btn btn-primary me-1"
                >
                    <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    Save
                </button>
                <button
                    @click="goToList"
                    class="btn btn-outline-secondary cancel-btn"
                >
                    Cancel
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import handleCBusinesses from '@/services/modules/businesses'
import {inject} from 'vue'
import TitleButton from '@/components/atom/TitleButton'
import AddFormElement from '@/components/molecule/business/AddFormElement'
import AddButton from '@/components/atom/AddButton'

export default {
    name: 'EditBusiness',
    components: {
        TitleButton,
        AddFormElement,
        AddButton
    },
    data: () => ({
        businesses: [],
        business: {
            name: '',
            type: null,
            status: '',
            updated_by: null,
            company_id: null,
        },
        errors: {
            name: '',
            type: '',
        }
    }),
    methods: {
        anyValidationError(){
            let flag = false;

            if(!this.business.name){
                this.showError('Name is required')
                flag = true;
            }

            return flag;
        },
        async getBusiness() {
            try {
                this.loading = true
                let businessId = this.$route.params.businessId
                let companyId = this.$route.params.companyId
                let res = await this.fetchSingleBusiness(businessId, companyId)
                if (!res.status) {
                    this.showError(res.message)
                }
                if (res.status) {
                    this.business = res.data
                }
            } catch (err) {
                if (!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if (err.response) {
                    this.showError(err.response.message)
                }
            } finally {
                this.loading = false
            }
        },
        goToList() {
            this.$router.push({
                name: 'business-list',
                params: {
                    companyId: this.$route.params.companyId,
                    moduleId: this.$route.params.moduleId,
                    menuId: this.$route.params.menuId,
                    pageId: this.$route.params.pageId
                },
                query: {
                    start: this.start,
                    end: this.end
                }
                
            })
        },
        getFormData() {
            let formData = new FormData();
            Object.keys(this.business).forEach(i => {
                formData.append(i, this.business[i])
            })
            return formData;
        },
        async saveBusiness(redirect = false) {

            if(this.anyValidationError()) return;

            this.business.updated_by = this.$store.getters["user/getUser"].id
            this.business.company_id = this.$route.params.companyId
            let data = this.getFormData();
            
            if (redirect) {
                this.loading = true
            } else {
                this.saveNewLoader = true
            }
            try {
                let res = await this.updateBusiness(this.$route.params.businessId, data)
                if (!res.status) {
                    this.showError(res.message)
                }
                if (res.status) {
                    this.showSuccess(res.message)
                    this.resetForm()
                    if (redirect) this.goToList()
                }
            } catch (err) {
                if (!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if (err.response) {
                    this.showError(err.response.data.message)
                }
            } finally {
                this.loading = false
                this.saveNewLoader = false
            }
        },
        resetForm() {
            this.business = {
                name: '',
                status: '',
                company_id: null,
                updated_by: null,
            }
        },
    },
    setup() {
        const showError = inject('showError');
        const showSuccess = inject('showSuccess');
        
        const {
            fetchSingleBusiness,
            updateBusiness,
            loading,
        } = handleCBusinesses()
        
        return {
            fetchSingleBusiness,
            updateBusiness,
            showError,
            showSuccess,
            loading
        }
    },
    
    mounted() {
        this.getBusiness()
    }
}
</script>
